import React, { useState, useEffect } from "react";
import "./AnnualReports.css";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const AnnualReports = () => {
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Default fallback icon
  const defaultPdfIcon = "/assets/images/newan2.png";

  useEffect(() => {
    const fetchAnnualReports = async () => {
      try {
        const response = await api.get(
          "/api/sitepages/academic/annual-reports",
        );
        const data = response.data;

        if (data.status && data.data) {
          // ✅ Apply the path fix during data fetching
          const formattedData = formatPaths(data.data);
          setReportData(formattedData);
        } else {
          throw new Error("Invalid data structure");
        }

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching Annual Reports data:", err);
        setError("Failed to load Annual Activity Reports");
        setIsLoading(false);
      }
    };

    fetchAnnualReports();
  }, []);

  /**
   * ✅ Path Fixer: Ensures the URL is: BASE_URL + /public + /storage/...
   */
  const formatPaths = (data) => {
    const formattedData = { ...data };
    const baseUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");

    // Format Individual Reports (Images and PDFs)
    if (formattedData.reports && Array.isArray(formattedData.reports)) {
      formattedData.reports = formattedData.reports.map((report) => ({
        ...report,
        // Fixing the "image" key for book thumbnails
        image:
          report.image && !report.image.startsWith("http")
            ? `${baseUrl}/public${report.image}`
            : report.image,
        pdf_url:
          report.pdf_url && !report.pdf_url.startsWith("http")
            ? `${baseUrl}/public${report.pdf_url}`
            : report.pdf_url,
      }));
    }

    return formattedData;
  };

  if (isLoading) return null;

  if (error) {
    return <div className="alert alert-danger text-center m-4">{error}</div>;
  }

  // Extracting dynamic data
  const bannerTitle = reportData.banner_title || "";
  const bannerImages = reportData.banner_images || [];
  const mobileBannerImages = reportData.mobile_banner_images || [];
  const sectionHeading =
    reportData.section_heading || "ANNUAL ACTIVITY REPORTS";
  const reportsList = reportData.reports || [];

  return (
    <div className="annual-reports-page">
      {/* ✅ Banner Section */}
      {bannerImages.length > 0 && (
        <DynamicBanner
          title={bannerTitle}
          bgImage={bannerImages}
          bgImageMobile={mobileBannerImages}
        />
      )}

      <section className="annual-reports-section pt_80 pb_80">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{sectionHeading}</h2>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {reportsList.map((report, index) => (
              <div key={index} className="col-md-4 col-12 mb-3">
                <div className="card-pdf">
                  <a
                    href={report.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    <div className="card newsletter-card d-flex flex-row align-items-center">
                      <div className="book">
                        {/* ✅ Dynamic Image from API key "image" */}
                        <img
                          src={report.image || defaultPdfIcon}
                          alt={report.title}
                          className="img-fluid"
                          style={{
                            width: "90px",
                            height: "90px",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defaultPdfIcon;
                          }}
                        />
                      </div>
                      <div className="d-flex align-items-center p-2">
                        <strong>{report.title}</strong>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnnualReports;
